import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getApplication, getRestaurant } from "../../utils/commons";

class Footer extends Component {
	scrollToTop() {
		window.scrollTo({
			top: 0,
			behavior: "smooth",
		});
	}
	render() {
		const application = getApplication();
		const restaurant = getRestaurant();

		return (
			<footer className={this.props.footer.style}>
				{/* Middle Footer */}
				<div className="footer-middle">
					<div className="container">
						<div className="row">
							<div className="offset-lg-3 col-lg-3 col-md-6 col-12 footer-widget">
								<div className="footer-logo">
									<a href="/">
										<img
											alt="Logo"
											src={
												process.env.REACT_APP_PUBLIC_URL +
												"/" +
												application.logo
											}
										/>
									</a>
								</div>
								<div>{restaurant.description}</div>
								<div>
									<h5 className="widget-title">Rejoignez-nous</h5>
									<ul className="social-media">
										{!!restaurant.facebookPageUrl && (
											<li>
												{" "}
												<a
													href={restaurant.facebookPageUrl}
													className="facebook"
													target="_blank"
												>
													{" "}
													<i className="fab fa-facebook-f" />{" "}
												</a>
											</li>
										)}
										{!!restaurant.instagramPageUrl && (
											<li>
												<a
													href={restaurant.instagramPageUrl}
													className="instagram"
													target="_blank"
												>
													{" "}
													<i className="fab fa-instagram" />{" "}
												</a>{" "}
											</li>
										)}
										{!!restaurant.snapchatPageUrl && (
											<li>
												<a
													href={restaurant.snapchatPageUrl}
													className="snapchat"
													target="_blank"
												>
													<i className="fab fa-snapchat-ghost" />{" "}
												</a>{" "}
											</li>
										)}
										{/* {!!restaurant.tiktokPageUrl && (
											<li>
												<a
													href={restaurant.tiktokPageUrl}
													className="tiktok"
													target="_blank"
												>
													<i className="fab fa-tiktok" />{" "}
												</a>{" "}
											</li>
										)} */}
										{/* <li>
										{" "}
										<Link to="#" className="twitter">
											{" "}
											<i className="fab fa-twitter" />{" "}
										</Link>{" "}
									</li> */}
									</ul>
								</div>
							</div>
							<div className="col-lg-3 col-md-6 col-12 footer-widget">
								<h5 className="widget-title">Coordonnées</h5>
								<div>
									<p>
										<i className="fas fa-map-marker-alt mr-2" />
										{restaurant.address + ", "} <br />
										{restaurant.zipCode + " " + restaurant.city}
									</p>
									<p>
										<i className="fas fa-phone mr-2" />
										{restaurant.landline}
									</p>
									{/* <li>
										{" "}
										<Link to="#" className="twitter">
											{" "}
											<i className="fab fa-twitter" />{" "}
										</Link>{" "}
									</li> */}
								</div>
							</div>
							{/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-12 footer-widget">
								<h5 className="widget-title">Information</h5>
								<ul>
									<li>
										{" "}
										<Link to="/">Home</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/blog-grid">Blog</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/about">About Us</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/">Menu</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/contact">Contact Us</Link>{" "}
									</li>
								</ul>
							</div> */}
						</div>
					</div>
				</div>
				{/* Footer Bottom */}
				<div className="footer-bottom">
					<div className="container">
						<div className="row content">
							<div className="col-md-8">
								<ul className="bottom-links">
									<li>
										{" "}
										<Link to="/mentions-legales">Mentions légales</Link>{" "}
									</li>
									{/* <li>
										{" "}
										<Link to="/protection-des-donnees">
											Protection des données
										</Link>{" "}
									</li>
									<li>
										{" "}
										<Link to="/conditions-generales-ventes">
											Conditions Générales de Ventes
										</Link>{" "}
									</li> */}
								</ul>
							</div>
							<div className="col-md-4 text-right mangopay-link">
								<a href="/cgu-mangopay.pdf">
									CGU Mangopay
									<img
										alt="MangoPay"
										src="/assets/img/MangoPay_Logo_White.png"
									/>
								</a>
							</div>
						</div>
						<div className="footer-copyright">
							<p>
								{" "}
								Copyright © 2023{" "}
								<a href="https://drive-eat.solutions/">Drive Eat</a> Tous droits
								réservés.{" "}
							</p>

							<Link
								to="#"
								className="back-to-top"
								onClick={() => this.scrollToTop()}
							>
								<i className="fas fa-chevron-up" />{" "}
							</Link>
						</div>
					</div>
				</div>
			</footer>
		);
	}
}

export default Footer;
